import React from 'react';
import { useEffect } from 'react';
import 'aos/dist/aos.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Services2 from '../components/Services2';
import ServiceSection from '../components/ServicesSection';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.min.css';




const Service = () => {
useEffect(() => {
  if (typeof window.AOS !== 'undefined') {
    window.AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      mirror: false
    });
  }
  // Initialize GLightbox for video modal
  const lightbox = GLightbox({
    selector: '.glightbox'
  });
  return () => {
    // Clean up
    if (lightbox) lightbox.destroy();
  };
}, []);


  return (
    <main className="main">
      
        <link rel="canonical" href="https://www.zaoafrika.co.ke/" />
        <title>Zao Afrika | Empowering Farmers, Growing Futures</title>
        <meta
          name="description"
          content="Zao Afrika empowers farmers through organic farming, value addition, and access to premium markets. Discover our contract farming, agri-tech solutions, and high-value crop portfolio."
        />
      
      <Header />

      {/* Page Title */}
      <div className="page-title dark-background" style={{ backgroundImage: 'url(assets/img/page-title-bg.webp)' }}>
        <div className="container position-relative">
          <nav className="breadcrumbs">
            <h1>Our Services</h1>
            <p>
              At Zao, we simplify farming with easy, effective services to help you plant, nurture, and
              harvest your crops. Our straightforward approach makes agriculture accessible and efficient.
            </p>
          </nav>
        </div>
      </div>

      {/* Services Section */}

      <ServiceSection />


      {/* Services 2 Section */}
      <Services2 />


      
      {/* Footer */}
      <Footer />
    </main>
    
  );
};

export default Service;